export function dispatchEvent(event: string, data) {
  const e = new CustomEvent(`mcfx:${event}`, {
    detail: data,
  });

  window.dispatchEvent(e);
}
